import React from "react";
import PropTypes from "prop-types";
import { Col, Row, Form, Input, Label, Button } from "reactstrap";
import SpinnerLabel from "common/components/spinner-label";

const propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  client: PropTypes.shape({
    full_name: PropTypes.string,
    email: PropTypes.string,
    agent_name: PropTypes.string,
    agent_email: PropTypes.string,
    send_a_copy: PropTypes.bool
  }).isRequired,
  isAdding: PropTypes.bool.isRequired
};

const AddClient = ({ onSubmit, onChange, client, isAdding }) => {
  const handleOnChange = e => {
    const { name, value } = e.target;
    onChange(name, value);
  };

  return (
    <Form onSubmit={onSubmit}>
      <Row className="mb-1">
        <Col xs="12" md className="mb-2">
          <Label for="campaign_client_full_name" className="font-weight-bold">
            Client&#39;s Name*
          </Label>
          <Input
            onChange={handleOnChange}
            minLength="1"
            maxLength="50"
            required
            placeholder="Enter client name (required)"
            value={client.full_name}
            name="full_name"
            id="full_name"
          />
        </Col>

        <Col xs="12" md className="mb-2">
          <Label for="campaign_client_email" className="font-weight-bold">
            Client&#39;s email address*
          </Label>
          <Input
            onChange={handleOnChange}
            minLength="1"
            maxLength="100"
            required
            placeholder="Enter client's email address (required)"
            value={client.email}
            type="email"
            name="email"
            id="email"
          />
          <small>
            *We will <span className="font-weight-bold">never</span> share this email with anyone.
          </small>
        </Col>
      </Row>
      <Row className="mb-1">
        <Col xs="12" md className="mb-2">
          <Label for="campaign_client_agent_name" className="font-weight-bold mb-0 pr-4">
            Agent Name
          </Label>
          <Input
            onChange={handleOnChange}
            minLength="1"
            maxLength="100"
            placeholder="Enter agent name"
            id="agent_name"
            name="agent_name"
            value={client.agent_name}
          />
        </Col>
        <Col xs="12" md className="mb-2">
          <Label for="campaign_client_agent_email" className="font-weight-bold mb-0">
            Reply-to email address
          </Label>
          <Input
            style={{ opacity: 0.45 }}
            minLength="1"
            maxLength="100"
            placeholder="your email"
            id="agent_email"
            disabled
            defaultValue={client.agent_email}
          />
        </Col>
      </Row>
      <Row>
        <Col className="ml-4 pb-2">
          <Label check>
            <Input
              onChange={e => {
                const { name, checked } = e.target;
                onChange(name, checked);
              }}
              type="checkbox"
              checked={client.send_a_copy}
              name="send_a_copy"
              id="send_a_copy"
            />{" "}
            Always send me a copy.
          </Label>
        </Col>
      </Row>

      <Button disabled={isAdding} color="primary btn-sharp" size="lg" type="submit">
        <SpinnerLabel spin={isAdding} label="Add" />
      </Button>
    </Form>
  );
};

AddClient.propTypes = propTypes;

export default AddClient;
